// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__tz2BM","left":"styles_left__DHJnC"};